const REDIRECT_URL = process.env.REACT_APP_GIFTLY_URL;

export const goToGiftly = (to = 'auth/sign-in') => window.open(`${REDIRECT_URL}/${to}`, '_blank');
